import Vue from 'vue';
import Element from 'element-ui';
import elemIt from 'element-ui/lib/locale/lang/it';
import locale from 'element-ui/lib/locale';
import { sync } from 'vuex-router-sync';
import {
  ValidationProvider,
  ValidationObserver,
  localize,
} from 'vee-validate/dist/vee-validate.full.esm';
import moment from 'moment';

import it from 'vee-validate/dist/locale/it.json';

import globalFilters from './globalFilters';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';

Vue.config.productionTip = false;

// Install vee-validate locales
localize({
  it,
});
// Set default locale
localize('it');
moment.locale('it');

sync(store, router);

// Setting element ui language
locale.use(elemIt);
Vue.use(Element);
Vue.use(globalFilters);

Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);

new Vue({
  router,
  i18n,
  store,
  render: (h) => h(App),
}).$mount('#app');
